<template>
    <pendo-router-link
        v-pendo-tooltip="{
            classes: 'side-nav-tooltip',
            content: tooltipContent,
            placement: 'right',
            arrow: true,
        }"
        pendo-analytics="salesforce-nav-item"
        class="nav-option"
        :to="{ name: 'SalesforceUpsell' }"
        :class="{ selected, expanded }"
        :aria-label="label"
        @click="$emit('toggle', $event)"
        @keyup.enter="$emit('toggle', $event)">
        <div class="nav-icon">
            <svg
                class="filled-icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.5 11.5C18.2 8.8 15.8 6.5 12 6.5C9.5 6.5 7.3 7.8 6.2 9.8C4.1 10.1 2.5 11.9 2.5 14.5C2.5 17.3 4.7 19.5 7.5 19.5H18C20.2 19.5 22 17.7 22 15.5C22 13.5 20.3 11.8 18.5 11.5Z"
                    fill="var(--palette-gray-90)"
                    stroke="var(--palette-gray-90)"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>
            <svg
                class="empty-icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.5 11.5C18.2 8.8 15.8 6.5 12 6.5C9.5 6.5 7.3 7.8 6.2 9.8C4.1 10.1 2.5 11.9 2.5 14.5C2.5 17.3 4.7 19.5 7.5 19.5H18C20.2 19.5 22 17.7 22 15.5C22 13.5 20.3 11.8 18.5 11.5Z"
                    stroke="var(--palette-gray-90)"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>
        </div>

        <div
            v-show="expanded"
            class="nav-label">
            <span class="label-text">{{ label }}</span>
            <upsell-tag />
        </div>
    </pendo-router-link>
</template>

<script>
import PendoRouterLink from '@/vue-router/pendo-router-link.vue';
import { PendoTooltip } from '@pendo/components';
import UpsellTag from '@/common/tags/upsell-tag.vue';

export default {
    name: 'SalesforceNavItem',
    compatConfig: {
        INSTANCE_LISTENERS: false,
    },
    components: {
        PendoRouterLink,
        UpsellTag,
    },
    directives: {
        PendoTooltip,
    },
    props: {
        selected: {
            type: Boolean,
            default: false,
        },
        expanded: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['toggle'],
    computed: {
        tooltipContent () {
            if (this.expanded) return '';

            return this.$t('sideNav.Available upgrade: Salesforce');
        },
        label () {
            return this.$t('sideNav.salesforce.Salesforce');
        },
    },
};
</script>

<style scoped lang="less">
@import '@/side-nav/nav.style.less';
</style>
